import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-too-many-attempts-svg',
  template: `<div class="svg-container">
  <svg height="66px" width="93px" viewBox="0 0 93 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Forgot-Password" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Reset-password-too-many-attempts" transform="translate(-143.000000, -126.000000)">
              <g id="09_ITEM/Hero/Email_in_use" transform="translate(140.000000, 104.000000)">
                  <g id="np_email_1561843_737373" transform="translate(3.000000, 22.000000)" fill="#737373">
                      <path d="M3.0312,0 C1.414,0 0,1.3477 0,3 L0,51 C0,52.6523 1.4141,54 3.0312,54 L86.9692,54 C88.5864,54 90.0004,52.6523 90.0004,51 L90.0004,3 C90.0004,1.3477 88.5863,0 86.9692,0 L3.0312,0 Z M3.99995,4 L85.99995,4 L85.99995,8.9375 L44.99995,37.5315 L3.99995,8.9375 L3.99995,4 Z M3.99995,13.8125 L25.03095,28.5005 L3.99995,47.4065 L3.99995,13.8125 Z M85.99995,13.8125 L85.99995,47.4065 L64.96895,28.5005 L85.99995,13.8125 Z M28.40595,30.8435 L43.84395,41.6245 C44.53536,42.11278 45.46505,42.11278 46.15645,41.6245 L61.59445,30.8435 L82.90645,49.9995 L7.09445,49.9995 L28.40595,30.8435 Z" id="Shape" fill-rule="nonzero"></path>
                  </g>
                  <g id="Group" transform="translate(66.000000, 60.000000)">
                      <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="15" cy="15" r="15"></circle>
                      <path d="M15.5,27 C8.59644063,27 3,21.4035594 3,14.5 C3,7.59644063 8.59644063,2 15.5,2 C22.4035594,2 28,7.59644063 28,14.5 C28,21.4035594 22.4035594,27 15.5,27 Z M15.5,23.875 C20.6776695,23.875 24.875,19.6776695 24.875,14.5 C24.875,9.32233047 20.6776695,5.125 15.5,5.125 C10.3223305,5.125 6.125,9.32233047 6.125,14.5 C6.125,19.6776695 10.3223305,23.875 15.5,23.875 Z" id="Combined-Shape" fill="#BF4B49" fill-rule="nonzero"></path>
                      <text id="!" font-family="NotoSans-Bold, Noto Sans" font-size="16" font-weight="bold" fill="#BF4B49">
                          <tspan x="12" y="20">!</tspan>
                      </text>
                  </g>
              </g>
          </g> 
      </g>
  </svg></div>`
})
export class TooManyAttemptsSvgComponent {
}
